import { useEffect, useState } from 'react'

import {
  collection,
  DocumentData,
  documentId,
  query,
  QueryDocumentSnapshot,
  where,
} from 'firebase/firestore'
import { useParams } from 'react-router-dom'
import { useCollection } from 'react-firebase-hooks/firestore'

import EventDetailsViewComponentDataKey from './EventDetailsViewComponentDataKey'
import EventDetailsViewComponentFeeSection from './EventDetailsViewComponentFees'
import EventDetailViewComponentPolicies from './EventDetailViewComponentPolicies'
import EventDetailViewComponentStaffSection from './EventDetailViewComponentStaffSection'
import { RedTitle } from './global/RedTitle'
import MoreButton from './global/MoreButton'
import EventDetailViewComponentPaperwork from './EventDetailViewComponentPaperwork'
import EventDetailViewComponentPointOfContact from './EventDetailViewComponentPointOfContact'
import EventDetailViewMap from './EventDetailViewComponentMap'
import HorizantalDivider from './global/HorizantalDivider'
import EventDetailViewComponentRegisterBox from './EventDetailViewComponentRegisterBox'

import { arrangeEventstaff, getConvertedData } from '../../../../models/interface.helper'
import { getUserFullName } from '../../../../helpers/helpers'

import FirestoreService from '../../../../services/firestoreService'
import FirebaseApp from '../../../../services/firebaseApp'

import { EventStaffModel } from '../../../../models/event-staff/event-staff.model'
import { EventModel } from '../../../../models/events/event.model'
import { UserPublicModel } from '../../../../models/users-public/users-public.model'

import { MODAL_CONSTS } from '../../../../const/modal-const'
import { CONST } from '../../../../const/const'

import { IUserPublicInterface } from '../../../../models/users-public/users-public.interface'
import { IEventStaffInterfaceTypes as iesit } from '../../../../models/event-staff/event-staff.interface'
import { IEventInterface } from '../../../../models/events/event.interface'
import { ISelectedEvent } from '../../../../store/events/eventsSlice'

type EventDetailTabProps = {
  handleModal?: (showHide: boolean, typeOfModal: string, data?: any) => void
  setExhibitorsModalShow?: any
  dataToPassOn?: any
  organizerDetails: IUserPublicInterface | null
  selectedEvent: ISelectedEvent
}

const COLLECTIONS = CONST.DATA.FIRESTORE.V01.COLLECTIONS

interface NewlineTextProps {
  text: string
}

function NewlineText({ text }: NewlineTextProps) {
  return <span style={{ whiteSpace: 'pre-line' }}>{text}</span>
}

const EventDetailTab = (props: EventDetailTabProps) => {
  const { handleModal, setExhibitorsModalShow, dataToPassOn, organizerDetails, selectedEvent } =
    props

  const EVENT_DATA = COLLECTIONS.EVENTS

  const params = useParams<{ eventId: string }>()
  const eventId = params?.eventId

  const EventFirebaseQueries: any[] = (function (): any {
    let queries: any = []
    if (eventId) {
      queries.push(where(documentId(), '==', eventId))
    }
    return queries
  })()

  const [eventStaffData, setEventStaffData] = useState<iesit['IStaffUiListItem'][]>([])
  const [eventTableData, setEventTableData] = useState<IEventInterface | null>(null)

  const [event] = useCollection(
    query(collection(FirebaseApp.firestore, EVENT_DATA.NAME), ...EventFirebaseQueries),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  )

  useEffect(() => {
    if (typeof dataToPassOn === 'number' && eventTableData?.id) {
      setEventTableData({
        ...eventTableData,
        waitlistCount: Number(eventTableData.waitlistCount ?? 0) + dataToPassOn,
      })
    }
  }, [dataToPassOn])

  useEffect(() => {
    const getEvents = function () {
      const fetched_events =
        event?.docs.map((doc) => {
          let EventsData = EventModel.fromFirestoreDoc(doc).toObject()
          return getConvertedData(EventsData)
        }) ?? []

      if (fetched_events.length) {
        const eventDetailData = fetched_events[0]
        setEventTableData(eventDetailData)
      }
    }
    getEvents()
  }, [event])

  useEffect(() => {
    async function updateStaffUi() {
      const savedEventStaff = new EventStaffModel(selectedEvent.EventStaff)
      let users: IUserPublicInterface[] = []
      let userIdsToFind: string[] = []
      let foundUser: IUserPublicInterface | null = null
      let usersLocal: iesit['IStaffUiItem'][] = []
      let usersSnap: QueryDocumentSnapshot<DocumentData>[] = []

      try {
        let structuredStaffs = arrangeEventstaff(savedEventStaff)

        structuredStaffs.forEach((currItem) => {
          currItem.staffs.forEach((curr) => {
            if (!!curr) {
              userIdsToFind.push(curr.staffId)
            }
          })
        })

        userIdsToFind = [...new Set(userIdsToFind)]
        usersSnap = await FirestoreService.getItemsUsingIds(
          COLLECTIONS.USERS_PUBLIC.NAME,
          userIdsToFind
        )
        usersSnap.forEach((curr) => users.push(UserPublicModel.fromFirestoreDoc(curr).toObject()))
        structuredStaffs = structuredStaffs.map((currItem) => {
          return {
            ...currItem,
            staffs: (function () {
              usersLocal = []
              currItem.staffs.forEach((currStaff) => {
                if (typeof currStaff !== 'string' && !!currStaff) {
                  foundUser = users.find((user) => user.id === currStaff.staffId) ?? null
                  if (foundUser)
                    usersLocal.push({
                      staffId: foundUser.id,
                      staffName: getUserFullName(foundUser),
                      staffType: currStaff.staffType,
                      staffProfilePicture: foundUser.userProfilePicture,
                    })
                }
              })
              return usersLocal
            })(),
          }
        })

        setEventStaffData(structuredStaffs)
      } catch (error) {
        console.error(error, 'error')
      }
    }

    if (selectedEvent?.EventStaff?.eventStaff?.length) updateStaffUi().then()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEvent?.EventStaff?.eventStaff])

  // Functions

  const openMoreModal = (title: string, data: string) => {
    if (typeof props?.handleModal === 'function') {
      props?.handleModal(true, MODAL_CONSTS.SEE_MORE, {
        title,
        dataToShow: data ? <NewlineText text={data} /> : "No 'About' information available.",
        headingClassName: '!text-SeabiscuitDark200ThemeColor',
        bodyClassName: 'min-h-[60vh] text-SeabiscuitDark200ThemeColor text-[16px]',
      })
    }
  }

  return (
    <>
      {/* side card for info */}
      <div className="lg:hidden">
        <EventDetailViewComponentRegisterBox
          EventDetails={selectedEvent?.EventDetails}
          EventTickets={selectedEvent?.EventTickets}
          handleModal={handleModal}
          companyLogo={organizerDetails?.userProfilePicture}
          eventTableData={eventTableData}
          companyName={organizerDetails ? getUserFullName(organizerDetails) : ''}
          exhibitorsModal={() => setExhibitorsModalShow(true)}
        />
        <HorizantalDivider />
      </div>
      {/* side card for info */}

      <div className="hidden lg:block">
        <EventDetailsViewComponentDataKey selectedEvent={selectedEvent} />
        <HorizantalDivider />
      </div>

      {selectedEvent?.EventDetails?.summaryLong &&
      selectedEvent?.EventDetails?.summaryLong !== '' ? (
        <>
          <RedTitle text="About" className="mb-1" />
          <p className="mt-4 text-SeabiscuitDark200ThemeColor leading-8 mb-2 overflow-hidden">
            {selectedEvent?.EventDetails?.summaryLong ? (
              <>
                {selectedEvent?.EventDetails?.summaryLong?.length > 500
                  ? `${selectedEvent?.EventDetails?.summaryLong.slice(0, 500)}... `
                  : selectedEvent?.EventDetails?.summaryLong}
                {selectedEvent?.EventDetails?.summaryLong?.length > 500 ? (
                  <MoreButton
                    onClick={() =>
                      openMoreModal('About', selectedEvent?.EventDetails?.summaryLong || '')
                    }
                    className="mt-2"
                  />
                ) : null}
              </>
            ) : (
              selectedEvent?.EventDetails?.summaryLong
            )}
          </p>
          <HorizantalDivider />
        </>
      ) : null}

      <div className="block lg:hidden">
        <RedTitle text="Key data" className="mb-4 sm:mb-7" />
        <EventDetailsViewComponentDataKey selectedEvent={selectedEvent} />
        <HorizantalDivider />
      </div>

      <RedTitle className="clear-both mb-4 sm:mb-7" text="Fees" />

      <EventDetailsViewComponentFeeSection
        selectedEvent={selectedEvent}
        handleModal={props.handleModal}
      />
      <HorizantalDivider />

      <RedTitle text="Policies" className="mb-4 sm:mb-7" />
      <EventDetailViewComponentPolicies
        handleModal={props.handleModal}
        policiesData={selectedEvent?.EventPolicies}
      />
      <HorizantalDivider />

      <RedTitle text="Staff" className="mb-4 sm:mb-7" />
      <EventDetailViewComponentStaffSection
        staffData={selectedEvent?.EventStaff}
        eventStaffData={eventStaffData}
      />
      <HorizantalDivider />

      <RedTitle text="Required Paperwork" className="mb-2" />
      <EventDetailViewComponentPaperwork selectedEvent={selectedEvent} />
      <HorizantalDivider />

      <RedTitle text="Point of contact" className="my-4 sm:my-7" />
      <EventDetailViewComponentPointOfContact eventData={selectedEvent?.EventDetails} />
      <HorizantalDivider />
      <RedTitle text="Location" className="my-4 sm:my-7" id="location_target" />
      <EventDetailViewMap eventData={selectedEvent?.EventDetails} />
    </>
  )
}

export default EventDetailTab
